module.exports = __webpack_public_path__ + "img/4.b8d5f6eb.jpg";